import React, { useState, useEffect } from 'react';
import { MdAdd } from 'react-icons/md';
import Select from 'react-select';
import SimpleModal from './SimpleModal'; // Your modal component path
import styled from 'styled-components';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import { Row, Col } from 'reactstrap';
import { renderCustomizedLabel } from './renderCustomLabel';
import { CustomLegend } from './CustomeLegend';

const AddButton = styled.button`
  cursor: pointer;
  background: transparent;
  border: none;
  font-size: 20px;
  color: #007BFF;
  position: relative;
  top: -7px;

  &:hover {
    background-color: transparent;
    color: #007BFF;
  }

`;

const FiltersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
`;
const COLORS = {
  Promoters: '#4CAF50',
  Passives: '#FFEB3B',
  Detractors: '#F44336',
};
const ChartContainer = styled.div`
  margin-top: 20px;
`;
const StyledSelect = styled(Select)`
  .my-custom-select {
    min-width: 200px; 
  }

`;
const DynamicFilterChartComponent = () => {
  // State hooks
  const [isModalOpen, setModalOpen] = useState(false);
  const [newTopicLabel, setNewTopicLabel] = useState('');
  const [selectedTopic, setSelectedTopic] = useState('');
  const [chartData, setChartData] = useState([]);

  const [topicsData, setTopicsData] = useState([
    { label: 'All', value: '' }, // Default option
    { label: 'Delivery', value: 'delivery' },
    { label: 'Pricing', value: 'pricing' },
    { label: 'User Experience', value: 'userExperience' },
  ]);
  // Functions to handle modal and topic addition
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const handleAddNewTopic = () => {
    addNewTopic(newTopicLabel); // Assume addNewTopic is implemented
    setNewTopicLabel(''); // Reset input
    closeModal(); // Close modal
  };


  // Initial static data, you would fetch this from a server in a real app


  // Example function to simulate different chart data based on the selected topic
  const getChartDataForTopic = (topic) => {
    switch (topic) {
      case 'delivery':
        return [{ name: 'Promoters', value: 200 }, { name: 'Detractors', value: 300 }, {
          name: 'Passives',
          value: 100,
        }];
      case 'pricing':
        return [{ name: 'Promoters', value: 100 }, { name: 'Detractors', value: 400 }, {
          name: 'Passives',
          value: 150,
        }];
      case 'userExperience':
        return [{ name: 'Promoters', value: 400 }, { name: 'Detractors', value: 100 }, {
          name: 'Passives',
          value: 200,
        }];
      default: // Default chart data (could represent combined data for all topics)
        return [{ name: 'Promoters', value: 300 }, { name: 'Detractors', value: 200 }, {
          name: 'Passives',
          value: 150,
        }];
    }
  };

  useEffect(() => {
    // Update chart data when the selected topic changes
    setChartData(getChartDataForTopic(selectedTopic));
  }, [selectedTopic]);


// Function to add a new topic
  const addNewTopic = (topicLabel) => {
    const newTopicValue = topicLabel.toLowerCase().replace(/\s+/g, ''); // Simplistic conversion to a 'value'
    const newTopic = { label: topicLabel, value: newTopicValue };
    setTopicsData([...topicsData, newTopic]);
    setSelectedTopic(newTopicValue);
  };

// Randomize data for the new topic
  useEffect(() => {
    if (!topicsData.find(t => t.value === selectedTopic)) {
      // This means the topic is newly added and does not exist in our predefined list
      setChartData([
        { name: 'Promoters', value: Math.floor(Math.random() * 100) + 1 },
        { name: 'Detractors', value: Math.floor(Math.random() * 100) + 1 },
        { name: 'Passives', value: Math.floor(Math.random() * 100) + 1 },
      ]);
    } else {
      // Proceed with the existing logic to set chart data based on selected topic
      setChartData(getChartDataForTopic(selectedTopic));
    }
  }, [selectedTopic, topicsData]);
  return (
    <div>
      <FiltersContainer>
        <Row>
          <Col>
            <h3 style={{ fontSize: '14px' }}>Filter by Topic</h3>

            <Row style={{minWidth:'200px',margin:0}}>
              <StyledSelect
                options={topicsData}
                onChange={({ value }) => setSelectedTopic(value)}
                placeholder='Select a topic'
                value={topicsData.find(t => t.value === selectedTopic)} // Ensure the select reflects the current topic
                  className="my-custom-select"
              />
              <AddButton onClick={openModal}><MdAdd /></AddButton>
            </Row>
          </Col>

          <SimpleModal isOpen={isModalOpen} onRequestClose={closeModal}>
            <input
              type='text'
              placeholder='Topic Name'
              value={newTopicLabel}
              onChange={(e) => setNewTopicLabel(e.target.value)}
            />
            <button onClick={handleAddNewTopic}>Add Topic</button>
          </SimpleModal>

        </Row>

      </FiltersContainer>
      <ChartContainer>

        <Row>
          <CustomLegend colors={COLORS} data={chartData} />
          <PieChart
            width={300}
            height={300}>
            <Pie
              data={chartData}

              labelLine={false}
              label={renderCustomizedLabel}

              fill='#8884d8'
              dataKey='value'
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[entry.name]} />
              ))}
            </Pie>
            <Tooltip />
            {/*<Legend layout='horizontal' verticalAlign='bottom' align='bottom' />*/}
          </PieChart>

        </Row>
      </ChartContainer>
    </div>
  );
};

export default DynamicFilterChartComponent;